"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensViewSessionContext = exports.LensRankingContext = exports.LensRankingContext_CameraDirection = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../google/protobuf/wrappers");
/** Direction in which the camera is facing */
var LensRankingContext_CameraDirection;
(function (LensRankingContext_CameraDirection) {
    /** CAMERA_DIRECTION_UNSET - Unset */
    LensRankingContext_CameraDirection[LensRankingContext_CameraDirection["CAMERA_DIRECTION_UNSET"] = 0] = "CAMERA_DIRECTION_UNSET";
    /** FRONT - Front facing */
    LensRankingContext_CameraDirection[LensRankingContext_CameraDirection["FRONT"] = 1] = "FRONT";
    /** BACK - Rear facing */
    LensRankingContext_CameraDirection[LensRankingContext_CameraDirection["BACK"] = 2] = "BACK";
    LensRankingContext_CameraDirection[LensRankingContext_CameraDirection["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LensRankingContext_CameraDirection = exports.LensRankingContext_CameraDirection || (exports.LensRankingContext_CameraDirection = {}));
function createBaseLensRankingContext() {
    return { lensViewSession: [], cameraDirection: 0 };
}
exports.LensRankingContext = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.lensViewSession) {
            exports.LensViewSessionContext.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.cameraDirection !== 0) {
            writer.uint32(16).int32(message.cameraDirection);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensRankingContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.lensViewSession.push(exports.LensViewSessionContext.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.cameraDirection = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLensRankingContext();
        message.lensViewSession =
            object.lensViewSession?.map((e) => exports.LensViewSessionContext.fromPartial(e)) || [];
        message.cameraDirection = object.cameraDirection ?? 0;
        return message;
    },
};
function createBaseLensViewSessionContext() {
    return {
        startTimestampMillis: undefined,
        totalLensViewTimeMillis: undefined,
        totalLensAdViewTimeMillis: undefined,
        totalLensViewCount: undefined,
        totalLensAdViewCount: undefined,
        totalLensAdSwipeUpCount: undefined,
        totalLensSwipeUpCount: undefined,
        totalLensAdLongformViewTimeMillis: undefined,
        totalLensSnapTakenCount: undefined,
        totalAdLensSnapTakenCount: undefined,
        totalLensShareCount: undefined,
        totalAdLensShareCount: undefined,
        totalLensSnapSendCount: undefined,
        totalAdLensSnapSendCount: undefined,
    };
}
exports.LensViewSessionContext = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.startTimestampMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.startTimestampMillis }, writer.uint32(10).fork()).ldelim();
        }
        if (message.totalLensViewTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.totalLensViewTimeMillis }, writer.uint32(18).fork()).ldelim();
        }
        if (message.totalLensAdViewTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.totalLensAdViewTimeMillis }, writer.uint32(26).fork()).ldelim();
        }
        if (message.totalLensViewCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalLensViewCount }, writer.uint32(34).fork()).ldelim();
        }
        if (message.totalLensAdViewCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalLensAdViewCount }, writer.uint32(42).fork()).ldelim();
        }
        if (message.totalLensAdSwipeUpCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalLensAdSwipeUpCount }, writer.uint32(50).fork()).ldelim();
        }
        if (message.totalLensSwipeUpCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalLensSwipeUpCount }, writer.uint32(58).fork()).ldelim();
        }
        if (message.totalLensAdLongformViewTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.totalLensAdLongformViewTimeMillis }, writer.uint32(66).fork()).ldelim();
        }
        if (message.totalLensSnapTakenCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalLensSnapTakenCount }, writer.uint32(74).fork()).ldelim();
        }
        if (message.totalAdLensSnapTakenCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalAdLensSnapTakenCount }, writer.uint32(82).fork()).ldelim();
        }
        if (message.totalLensShareCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalLensShareCount }, writer.uint32(90).fork()).ldelim();
        }
        if (message.totalAdLensShareCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalAdLensShareCount }, writer.uint32(98).fork()).ldelim();
        }
        if (message.totalLensSnapSendCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalLensSnapSendCount }, writer.uint32(106).fork()).ldelim();
        }
        if (message.totalAdLensSnapSendCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalAdLensSnapSendCount }, writer.uint32(114).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensViewSessionContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.startTimestampMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.totalLensViewTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.totalLensAdViewTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.totalLensViewCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.totalLensAdViewCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.totalLensAdSwipeUpCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.totalLensSwipeUpCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.totalLensAdLongformViewTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.totalLensSnapTakenCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.totalAdLensSnapTakenCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.totalLensShareCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.totalAdLensShareCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 13:
                    message.totalLensSnapSendCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 14:
                    message.totalAdLensSnapSendCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLensViewSessionContext();
        message.startTimestampMillis = object.startTimestampMillis ?? undefined;
        message.totalLensViewTimeMillis =
            object.totalLensViewTimeMillis ?? undefined;
        message.totalLensAdViewTimeMillis =
            object.totalLensAdViewTimeMillis ?? undefined;
        message.totalLensViewCount = object.totalLensViewCount ?? undefined;
        message.totalLensAdViewCount = object.totalLensAdViewCount ?? undefined;
        message.totalLensAdSwipeUpCount =
            object.totalLensAdSwipeUpCount ?? undefined;
        message.totalLensSwipeUpCount = object.totalLensSwipeUpCount ?? undefined;
        message.totalLensAdLongformViewTimeMillis =
            object.totalLensAdLongformViewTimeMillis ?? undefined;
        message.totalLensSnapTakenCount =
            object.totalLensSnapTakenCount ?? undefined;
        message.totalAdLensSnapTakenCount =
            object.totalAdLensSnapTakenCount ?? undefined;
        message.totalLensShareCount = object.totalLensShareCount ?? undefined;
        message.totalAdLensShareCount = object.totalAdLensShareCount ?? undefined;
        message.totalLensSnapSendCount = object.totalLensSnapSendCount ?? undefined;
        message.totalAdLensSnapSendCount =
            object.totalAdLensSnapSendCount ?? undefined;
        return message;
    },
};
//# sourceMappingURL=lens_ranking_context.js.map